// create
export const CREATE_GST_INVOICE_REQUEST = "CREATE_GST_INVOICE_REQUEST";
export const CREATE_GST_INVOICE_SUCCESS = "CREATE_GST_INVOICE_SUCCESS";
export const CREATE_GST_INVOICE_FAIL = "CREATE_GST_INVOICE_FAIL";

// get
export const GST_INVOICE_REQUEST = "GST_INVOICE_REQUEST";
export const GST_INVOICE_SUCCESS = "GST_INVOICE_SUCCESS";
export const GST_INVOICE_FAIL = "GST_INVOICE_FAIL";

// find
export const FIND_GST_INVOICE_REQUEST = "FIND_GST_INVOICE_REQUEST";
export const FIND_GST_INVOICE_SUCCESS = "FIND_GST_INVOICE_SUCCESS";
export const FIND_GST_INVOICE_FAIL = "FIND_GST_INVOICE_FAIL";

export const CLEAR_ERROR = "CLEAR_ERROR";
